export default "__VITE_ASSET__3a1b5861__"